// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2e591031","732":"1eb2181e","977":"1bdd7d95"}[chunkId] + ".chunk.js";
};